import { transformBillsAndVotesForUI } from 'redux/votingRecord/utils';

export function transformRollCallVotesForUI(rollCallVotesData = {}) {
  return transformBillsAndVotesForUI(rollCallVotesData);
}
